import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { GItem } from '@app/cp/shared/models/GItem';
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { Subscription } from 'rxjs';
import { PageChangeEvent, SelectableSettings, SelectionEvent } from '@progress/kendo-angular-grid';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { ConstContractHistory } from '@app/cp/shared/models/ConstContractHistory';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { aggregateBy } from '@progress/kendo-data-query';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { DispatchData } from '@app/cp/shared/models/DispatchData';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { CommonValues } from '@app/cp/shared/static/CommonValues';

@Component({
    selector: 'contract-history-search',
    templateUrl: './contract-history-search.component.html',
    styleUrls: ['./contract-history-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContractHistorySearchComponent extends BaseGridUIComponent<ConstContractHistory, null, ConstructionService>  implements OnInit, OnDestroy{

  contractStatusCF: MSCLFilterClass;
  customerCF: MSCLFilterClass;
  locationCF: MSCLFilterClass;
  contractAdminCF: MSCLFilterClass;
  contractProjAdminCF: MSCLFilterClass;

  constructor(svc_data: ConstructionService, globals: GlobalsService, private svc_cust: CustomerService
  ) {
    super(globals);
    this.svc_data = svc_data;
  }
  subs_data_custCBO: Subscription;
  subs_data_locCBO: Subscription;
  data_customersCBO: GItem[] = [];
  data_locationsCBO: GItem[] = [];

  selected_customer: GItem;
  selected_location: GItem;
  selected_type: string = "C";
  default_type: GItem = {
    "description": "All Dispatches & Jobs", "value": "A", "category": "", "reference": ""
  };
  search_note: string;
  openStatusesOnly: boolean = true;

  public selectableSettings: SelectableSettings;

  public setSelectableSettings(): void {
    this.selectableSettings = {
      checkboxOnly: false,
      mode: "single"
    };
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    CommonFunctions.unsubscribe(this.subs_data_custCBO);
  }

  override ngOnInit() {
    super.ngOnInit();
    CommonFunctions.unsubscribe(this.subs_data_custCBO);
    this.subs_data_custCBO = this.svc_cust.getCustomersForCBO().subscribe(data => {
      this.data_customersCBO = data;
    });
  }

  searchGrid() {
    this.gridData = null;
    this.skip = 0;
    this.getData();
  }
  getData() {
    this.dataLoading = true;

    let param: CommonParam = this.getParam(false);
    CommonFunctions.unsubscribe(this.subs_data);
    console.log("con-hist: ", param);
    this.subs_data = this.svc_data.getConstHistory(param).subscribe(
      {
        next:
          (info: BaseMessageInfo) => {
            if (info.saveError) {
              console.error(info);
              this.globals.notifyError(`Unable to retrieve search results. ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
              this.dataLoading = false;
              return;
            }
            console.log("con-hist-agd: ", info);
            if (CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
              this.ListData = info.primaryReturn;
            }
            this.dataLoading = false;
          },
        error: e => {
          console.error(e);
          this.globals.notifyError(`Unable to retrieve search results. ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
          this.dataLoading = false;
        }
    });

  }
  getParam(initial: boolean = false): CommonParam {
    let param: CommonParam = new CommonParam();
    if (!initial) {
      param.userId = this.globals.userId;
      param.companyId = this.globals.companyId;
      param.customerId = CommonFunctions.hasValue(this.selected_customer) ? this.selected_customer.value : null;
      param.locationId = CommonFunctions.hasValue(this.selected_location) ? this.selected_location.value : null;
      param.addParam("SelectCode", this.selected_type);
      param.addParam("OpenOnly", this.openStatusesOnly);
      param.addParam("NoteSearch", CommonFunctions.hasValue(this.search_note) ? this.search_note : null);
    }
    return param;
  }
  pageChange(e: PageChangeEvent) {
    this.getData();
  }
  searchServer() {

  }
  clear() {
    this.selectedData = null;
    this.gridData = null;
    this.selected_customer = null;
    this.selected_location = null;
    this.search_note = "";
  }
  customerCBOChanged(e: GItem) {
    if (!e?.value) {
      return;
    }
    this.selected_customer = e;
    CommonFunctions.unsubscribe(this.subs_data_locCBO);
    this.subs_data_locCBO = this.svc_cust.getCustomerLocationsForCBO(e.value).subscribe(data => {
      this.data_locationsCBO = data;
    });
  }
  locationCBOChanged(e: GItem) {
    this.selected_location = e;
  }
  openChanged(e: any) {
    this.openStatusesOnly = e;
  }
  allChanged(e: any) {
  }
  rowSelected(e: SelectionEvent) {
    this.selectedData = e.selectedRows[0].dataItem;
  }
  contractsJobs(code: string, e: any) {
    if (e === true) {
      this.selected_type = code;
    }
    console.log("contractsJobs: ", code, e);
  }
  processGridData() {
    if (CommonFunctions.hasArrayElementValue(this.gridData)) {
      this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
    }
    this.contractStatusCF = new MSCLFilterClass('contractStatus', 'contractStatus', this.gridData);
    this.customerCF = new MSCLFilterClass('customerName', 'customerName', this.gridData);
    this.locationCF = new MSCLFilterClass('locationName', 'locationName', this.gridData);
    this.contractAdminCF = new MSCLFilterClass('contractAdmin', 'contractAdmin', this.gridData);
    this.contractProjAdminCF = new MSCLFilterClass('contractProjAdmin', 'contractProjAdmin', this.gridData);
  }
  detailId: any;
  details(data: ConstContractHistory) {
    this.dqoiPopup(data.contractId, SearchTarget.contract, true);
    //this.detailOpened = true;
    //this.detailId = "1:" + data.dispatchId;
    ////this.dqoi.setupFromId(data.dispatchId);

  }
  detailOpened: boolean = false;
  closeDetail() {
    //this.dqoi.

    this.detailOpened = false;
  }
  detailsData: DispatchData;
  dqoiPopup(id: any, target: SearchTarget = SearchTarget.contract, isConstruction: boolean = true) {
    let data: DispatchData = new DispatchData();
    data.id = id;
    data.target = target;
    data.isConstruction = isConstruction;
    data.viewDispatch.dispatchId = id;
    this.detailsData = data;
    //this.cpPopWindow({ contentType: WindowContents.viewDispatch, boardData: data });
  }
  public cpActiveChildComp: number;
  public cpWindowData: any;
  public cpShowWindow: boolean = false;
  public cpContentTypes = WindowContents;
  cpPopWindow(injected: any) {
    this.cpActiveChildComp = injected.contentType;
    this.cpWindowData = injected.boardData;
    this.cpShowWindow = true;
  }
  onCPWindowClosed(e) {
    //        this.refreshData(DbTable.DispatchAssignments);
    this.cpShowWindow = false;
  }
}